//External libraries
import styled from '@emotion/styled';

// Internal modules
import { LANG_COUNTRY_DIVIDER_COLOR, LINK_COLOR } from '@/styles';

const LanguageButton = styled.button`
  background-color: transparent;
  border: 0;
  color: ${LINK_COLOR};
  cursor: pointer;
  font-size: 13px;
  line-height: 1.38;
  padding: 0 7.5px;
`;

const LanguageListContainer = styled.div`
  display: flex;
  padding-right: 12px;

  &::after {
    background-color: ${LANG_COUNTRY_DIVIDER_COLOR};
    content: '';
    left: 5px;
    margin-right: 1px;
    position: relative;
    width: 1px;
  }
`;

export { LanguageListContainer, LanguageButton };
